import React from 'react';
import { FormattedMessage } from '@dbk/format';
import { View } from '@dbk/ui-react-utils';
import config from '../../data/get-settings';
import AppFooter from './app-footer';

import AppNavAdmin from './app-nav-admin';
import RsaModal from '../common/rsa-modal';
import AppIdle from '../common/app-idle';
import InternetCheck from './internet-check';
import Alert from '../common/alert';
import cx from 'classnames';
import VascoModal from '../../screens/auth/vasco/vasco-modal';

const AdminPortal = props => {
  const {
    isVasco,
    isWebsso,
    screen: { isSmall },
    auth: { authorised, entitlementProcessed },
    i18n: { messages },
    children,
    ui: { history }
  } = props;
  const pageContentClasses = cx('content', {
    vasco: isVasco,
    isVasco,
  });

  const currentPath = history.currentLocation.pathname;
  const lastSegment = currentPath.split('/').pop();

  const displayNav = lastSegment !== 'admin';
  const displayPortfolioSelector = lastSegment === 'docsigncenter';

  return (
    <div className='app-container'>
      {displayNav && <AppNavAdmin />}
      <div className='app-admin'>
        <div className="content margin-top-100">
          <View className={pageContentClasses}>
            {children}
            {authorised &&
              <RsaModal
                title={<FormattedMessage id="app.token.header.title" />}
                doneLabel={messages['app.common.closeText']}
              />}
            {authorised && config.features.vascoAuth && entitlementProcessed && <VascoModal />}
          </View>
        </div>
        <AppFooter />
        {!isWebsso && authorised && <AppIdle />}
        <Alert />
        <InternetCheck />
      </div>
    </div>);
};

export default AdminPortal;
